import React, { useEffect } from "react";
import _ from "lodash";
import { EVENT_PLANNING_EQUIPMENT } from "../../../plannerConfig";
import {
  MultiWeekPlannerMainContainer,
  EquipmentWrapper,
  EquipmentFigureValue,
  EquipmentHorizontalHeader,
  EquipmentRow,
  EquipmentVerticalHeader,
} from "./styles";
import LoadSpinnerOverlay from "../../LoadSpinner";

const PEAK_PLANNED = "Peak Planned";
const PEAK_ROSTERED = "Peak Rostered";

const EquipmentView = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_EQUIPMENT];

  const getEquipmentData = () => {
    const { get } = api;
    const buildSelectedScenariosString = selectedScenarios
      .map((scenario) => `scenario_id=${scenario.id}`)
      .join("&");
    if (fromDate && toDate) {
      get([EVENT_PLANNING_EQUIPMENT], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: `${buildSelectedScenariosString}&`,
        },
      });
    }
  };

  useEffect(() => {
    getEquipmentData();
  }, [
    fromDate,
    toDate,
    fromDateFilter,
    toDateFilter,
    durationAggregator,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay text="Equipment Data Loading..." spinning={true} />
      </div>
    );
  }

  const {
    TableA: { title, data: EquipmentData, lables },
  } = data;

  const EquipmentDataKeys = Object.keys(EquipmentData);

  const getIsHighlighted = (data, label) => {
    if (label === PEAK_ROSTERED && data[PEAK_ROSTERED] !== "-") {
      return data[PEAK_PLANNED] < data[PEAK_ROSTERED];
    }
    return false;
  };

  return (
    <MultiWeekPlannerMainContainer style={{ overflowY: "auto" }}>
      <div style={{ width: "80%", height: "100%" }}>
        <EquipmentWrapper>
          <EquipmentRow>
            <EquipmentVerticalHeader>{title}</EquipmentVerticalHeader>
            {lables.map((label) => (
              <EquipmentHorizontalHeader>{label}</EquipmentHorizontalHeader>
            ))}
          </EquipmentRow>
          {EquipmentDataKeys.map((dataKey) => {
            return (
              <EquipmentRow key={dataKey}>
                <EquipmentVerticalHeader>{dataKey}</EquipmentVerticalHeader>
                {lables.map((label) => {
                  return (
                    <EquipmentFigureValue
                      highlighted={getIsHighlighted(
                        EquipmentData[dataKey],
                        label
                      )}
                    >
                      {EquipmentData[dataKey][label]}
                    </EquipmentFigureValue>
                  );
                })}
              </EquipmentRow>
            );
          })}
        </EquipmentWrapper>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default EquipmentView;
